export default function DropdownChevron() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12" viewBox="0 0 20 12" fill="none">
			<path
				opacity="0.4"
				d="M1 1.28125L10 10.2812L19 1.28125"
				stroke="#1F1F1F"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
